import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { IApplyTagsRequest, IApplyTagsResult, IUpdateTagsRequest, IUpdateTagsResult } from './models/tags';
import { AxiosRequestConfig, CancelToken, Method } from 'axios';

export default class TagsApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + 'services/tags/'
		};
	}

	public async updateTagsAsync(data: IUpdateTagsRequest, cancelToken?: CancelToken): Promise<IUpdateTagsResult> {
		const baseRequest = this.createBaseRequest();
		const request: AxiosRequestConfig = {
			...baseRequest,
			url: 'updatetags',
			method: 'post' as Method,
			data: data,
			cancelToken: cancelToken,
			headers: {
				...baseRequest.headers,
				'content-type': 'application/json'
			}
		};

		const response = await super.sendAsync<IUpdateTagsResult>(request);
		this.throwIfFailedResponse(response, localize('Error while applying changes.'));
		return response.data;
	}

	public async addTagsWithInfoAsync(data: IApplyTagsRequest, cancelToken?: CancelToken): Promise<IApplyTagsResult> {
		const baseRequest = this.createBaseRequest();
		const request: AxiosRequestConfig = {
			...baseRequest,
			url: 'addtagswithinfo',
			method: 'post' as Method,
			data: data,
			cancelToken: cancelToken,
			headers: {
				...baseRequest.headers,
				'content-type': 'application/json'
			}
		};

		const response = await super.sendAsync<IApplyTagsResult>(request);
		this.throwIfFailedResponse(response, localize('Error while adding tags.'));

		return response.data;
	}
}
